import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';

import { actions } from '../actions/audio';

type Audio = {
  id: string | null;
  name: string | null;
  url: string | null;
  created_by: string | null;
  created_at: string | null;
};

export function emptyAudio(): Audio {
  return {
    id: null,
    name: null,
    url: null,
    created_by: null,
    created_at: null,
  };
}

export type AudioState = {
  meta: {
    getAsyncStatus: AsyncStatus;
  };
  ui: {
    isNewAudioOpen: boolean;
  };
  allAudios: Array<Audio>;
  selectedAudio: Audio;
};

const initialState: AudioState = {
  meta: {
    getAsyncStatus: 'succeeded',
  },
  ui: {
    isNewAudioOpen: false,
  },
  allAudios: [],
  selectedAudio: emptyAudio(),
};

// Destructure the audio actions.
export const {
  audioGetAll,
  audioGetAllSucceeded,
  audioGetAllFailed,
  audioSelect,
  audioReset,
  audioShowModal,
  audioHideModal,
} = actions;

const audio = handleActions<AudioState, any>(
  {
    [audioGetAll.toString()]: (state: AudioState, action) => {
      return { ...state, meta: { ...state.meta, getAsyncStatus: 'loading' } };
    },

    [audioReset.toString()]: (state: AudioState, action) => {
      return { ...state, selectedAudio: emptyAudio() };
    },

    [audioGetAllSucceeded.toString()]: (state: AudioState, action) => {
      // Update selectedAudio.
      let selectedAudio = Object.assign({}, state.selectedAudio);
      if (selectedAudio.url !== null) {
        // Update the selectedAudio with the whole object (if known yet).
        for (const audio of action.payload.data.announcements) {
          if (audio.url === selectedAudio.url) {
            selectedAudio = audio;
            break;
          }
        }
      }

      return {
        ...state,
        meta: { ...state.meta, getAsyncStatus: 'succeeded' },
        allAudios: action.payload.data.announcements,
        selectedAudio: selectedAudio,
      };
    },

    [audioGetAllFailed.toString()]: (state: AudioState, action) => {
      return { ...state, meta: { ...state.meta, getAsyncStatus: 'failed' } };
    },

    [audioSelect.toString()]: (state: AudioState, action) => {
      let selectedAudio = Object.assign({}, action.payload.audio);

      // Update the selectedAudio with the whole object (if known yet).
      for (const audio of state.allAudios) {
        if (audio.url === action.payload.audio.url) {
          selectedAudio = audio;
          break;
        }
      }

      return { ...state, selectedAudio: selectedAudio };
    },

    [audioShowModal.toString()]: (state: AudioState, action) => {
      return { ...state, ui: { ...state.ui, isNewAudioOpen: true } };
    },

    [audioHideModal.toString()]: (state: AudioState, action) => {
      return { ...state, ui: { ...state.ui, isNewAudioOpen: false } };
    },
  },
  initialState,
);

export default audio;
